"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimAnalytics = void 0;
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const claim_analytics_header_1 = require("client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/components/claim-analytics-header");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
require("./claim-analytics.less");
const number_formatter_1 = require("./number-formatter");
const mobx_1 = require("mobx");
const store_2 = require("client/modules/users/store");
const Launch_1 = require("@material-ui/icons/Launch"); // E-017.2
// Need to pass the data into the component via props so that I can use the constructor function properly
// and not have to wait for the data to load because it is already being passed in.
let ClaimAnalytics = class ClaimAnalytics extends React.Component {
    constructor(props) {
        super(props);
        this.onRetryCLaim = true; //E-017.1
        this.mdsView = false;
        this.toNumericValue = (value) => {
            if (value === null || value === undefined || value === "") {
                return 0;
            }
            const numericValue = typeof value === "number"
                ? value
                : parseFloat(String(value).replace(/[$,]/g, ""));
            return isNaN(numericValue) ? 0 : numericValue;
        };
        // E-017.2 navigate
        this.CustomCellRendorIcon = (params) => {
            return (React.createElement("a", { href: `/claims/${params.value}`, target: "_blank", style: { cursor: 'pointer' } },
                React.createElement(Launch_1.default, null)));
        };
        this.onButtonExport = () => {
            const params = {
                fileName: "Claim_Analytics.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        //D-011
        this.allColumns = [
            {
                headerName: "Navigate",
                field: "OrderId",
                cellRendererFramework: this.CustomCellRendorIcon // E-017
            },
            {
                headerName: "Patient Name",
                field: "Patient Name",
                filter: "agTextColumnFilter",
                enableRowGroup: true
            },
            {
                headerName: "Pharmacy Name",
                field: "Pharmacy Name",
                enableRowGroup: true
            },
            {
                headerName: "Pharmacy State",
                field: "Pharmacy State",
                filter: "agTextColumnFilter",
                enableRowGroup: true
            },
            {
                headerName: "Adjudicated Claim Date(EST/EDT)",
                field: "Adjudicated Claim Date",
                filter: "agDateColumnFilter",
                // D-032.12 s
                filterParams: {
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        if (!cellValue)
                            return -1;
                        const dateParts = cellValue.split("/");
                        if (dateParts.length !== 3)
                            return -1;
                        const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                        }
                        return cellDate < filterLocalDateAtMidnight ? -1 : 1;
                    },
                    browserDatePicker: true
                },
                comparator: (date1Str, date2Str) => {
                    if (!date1Str)
                        return -1;
                    if (!date2Str)
                        return 1;
                    const dateParts1 = date1Str.split("/");
                    const dateParts2 = date2Str.split("/");
                    const date1 = new Date(Number(dateParts1[2]), Number(dateParts1[0]) - 1, Number(dateParts1[1]));
                    const date2 = new Date(Number(dateParts2[2]), Number(dateParts2[0]) - 1, Number(dateParts2[1]));
                    return date1.getTime() - date2.getTime();
                    // D-032.12 e
                }
            },
            {
                headerName: "Adjudicated Claim Time(EST/EDT)",
                field: "Adjudicated Claim Time",
                // filter: "agDateColumnFilter",
                filterParams: {
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        const dateAsString = cellValue;
                        if (dateAsString === null)
                            return -1;
                        const dateParts = dateAsString.split("/");
                        const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true
                }
            },
            {
                headerName: "Scheduled Claim Date",
                field: "Scheduled Claim Date",
                filter: "agDateColumnFilter",
                // D-032.12 s
                filterParams: {
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        if (!cellValue)
                            return -1;
                        const dateParts = cellValue.split("/");
                        if (dateParts.length !== 3)
                            return -1;
                        const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                        }
                        return cellDate < filterLocalDateAtMidnight ? -1 : 1;
                    },
                    browserDatePicker: true
                },
                comparator: (date1Str, date2Str) => {
                    if (!date1Str)
                        return -1;
                    if (!date2Str)
                        return 1;
                    const dateParts1 = date1Str.split("/");
                    const dateParts2 = date2Str.split("/");
                    const date1 = new Date(Number(dateParts1[2]), Number(dateParts1[0]) - 1, Number(dateParts1[1]));
                    const date2 = new Date(Number(dateParts2[2]), Number(dateParts2[0]) - 1, Number(dateParts2[1]));
                    return date1.getTime() - date2.getTime();
                    // D-032.12 e
                }
            },
            {
                headerName: "Scheduled Claim Time",
                field: "Scheduled Claim Time" // B-099
            },
            {
                headerName: "RX #",
                field: "RX #"
            },
            {
                headerName: "Payment Method",
                field: "Payment Method"
            },
            {
                headerName: "AWP",
                field: "AWP",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter",
                // D-032.12 s
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["AWP"]);
                }
                // D-032.12 e
            },
            {
                headerName: "Insurance Amount",
                field: "Insurance Amount",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Copay Amount",
                field: "Copay Amount",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Dispense Fee",
                field: "Dispense Fee",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Fee Type",
                field: "Fee Type",
                hide: true
            },
            {
                headerName: "Service Fee %",
                field: "Service Fee %",
                type: "numericColumn",
                filter: "agNumberColumnFilter"
            },
            {
                headerName: "Flat Rate Fee",
                field: "Flat Rate Fee",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter",
                hide: true
            },
            {
                headerName: "Transaction Fee",
                field: "Transaction Fee",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter",
                hide: true
            },
            {
                headerName: "Service Fee",
                field: "Service Fee",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter",
                // D-032.12 s
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["Service Fee"]);
                }
                // D-032.12 e
            },
            {
                headerName: "Product Unit Cost",
                field: "Product Unit Cost",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter",
                // D-032.12 s
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["Product Unit Cost"]);
                }
                // D-032.12 e
            },
            {
                headerName: "Product Cost",
                field: "Product Cost",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            // C-019_PROD
            {
                headerName: "Dispensing Reimbursement",
                field: "Dispensing Reimbursement",
                filter: "agTextColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter",
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["Dispensing Reimbursement"]);
                }
            },
            // C-019_PROD
            {
                headerName: "Net Reimbursement",
                field: "Net Reimbursement",
                filter: "agTextColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter",
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["Net Reimbursement"]);
                }
            },
            {
                headerName: "Med Name",
                field: "Med Name"
            },
            {
                headerName: "NDC #",
                field: "NDC #"
            },
            {
                headerName: "Quantity Dispensed",
                field: "Quantity Dispensed"
            },
            {
                headerName: "Fill Number",
                field: "Fill Number",
                hide: true,
            },
            {
                headerName: "Patient Bin",
                field: "Patient Bin"
            },
            {
                headerName: "Patient PCN",
                field: "Patient PCN"
            },
            {
                headerName: "Group Id",
                field: "Group Id"
            },
            {
                headerName: "Patient Birth Date",
                field: "Patient Birth Date"
            },
            {
                headerName: "Claim Status",
                field: "Claim Status"
            },
            {
                headerName: "Intent History",
                field: "Intent History",
                filter: "agDateColumnFilter",
                hide: true,
                filterParams: {
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        const dateAsString = cellValue;
                        if (dateAsString === null)
                            return -1;
                        const dateParts = dateAsString.split("/");
                        const cellDate = new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
                        if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                        }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                    },
                    browserDatePicker: true
                }
            },
            {
                headerName: "Error Message",
                field: "Error Message",
                filter: true
            },
            {
                headerName: "Cancel Reason",
                field: "Cancel Reason",
                filter: true
            },
            {
                headerName: "Pharmacy Notes",
                field: "Pharmacy Notes"
            },
            {
                headerName: "Provider Name",
                field: "Provider Name"
            },
            {
                headerName: "Portal User",
                field: "Portal User"
            }
        ];
        //D-011
        this.distColumns = [
            {
                headerName: "Pharmacy State",
                field: "Pharmacy State",
                filter: "agTextColumnFilter",
                enableRowGroup: true
            },
            {
                headerName: "Adjudicated Claim Date(EST/EDT)",
                field: "Adjudicated Claim Date",
                filter: "agDateColumnFilter",
                // D-032.12 s
                filterParams: {
                    // provide comparator function
                    comparator: (filterLocalDateAtMidnight, cellValue) => {
                        const dateAsString = cellValue;
                        if (dateAsString == null) {
                            return 0;
                        }
                        // In the example application, dates are stored as dd/mm/yyyy
                        // We create a Date object for comparison against the filter date
                        const dateParts = dateAsString.split('/');
                        const year = Number(dateParts[2]);
                        const month = Number(dateParts[1]) - 1;
                        const day = Number(dateParts[0]);
                        const cellDate = new Date(year, month, day);
                        // Now that both parameters are Date objects, we can compare
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        else if (cellDate > filterLocalDateAtMidnight) {
                            return 1;
                        }
                        return 0;
                        // D-032.12 e
                    }
                }
            },
            {
                headerName: "AWP",
                field: "AWP",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter",
                // D-032.12 s
                sortable: true,
                valueGetter: (params) => {
                    return this.toNumericValue(params === null || params === void 0 ? void 0 : params.data["AWP"]);
                }
                // D-032.12 e
            },
            {
                headerName: "Insurance Amount",
                field: "Insurance Amount",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Product Unit Cost",
                field: "Product Unit Cost",
                type: "numericColumn",
                filter: "agNumberColumnFilter",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Product Cost",
                field: "Product Cost",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Copay Amount",
                field: "Copay Amount",
                filter: "agNumberColumnFilter",
                type: "numericColumn",
                cellRenderer: "numberFormatter"
            },
            {
                headerName: "Quantity Dispensed",
                field: "Quantity Dispensed"
            },
            {
                headerName: "Med Name",
                field: "Med Name"
            },
            {
                headerName: "NDC #",
                field: "NDC #"
            },
            {
                headerName: "Patient Bin",
                field: "Patient Bin"
            },
            {
                headerName: "Patient PCN",
                field: "Patient PCN"
            },
            {
                headerName: "Group Id",
                field: "Group Id"
            }
        ];
        this.storeData = {
            // anything specified in defaultColDef gets applied on all columns
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
            },
            columnDefs: store_2.usersStore.user.value.groupId == 10 ||
                store_2.usersStore.user.value.groupId == 11 ||
                store_2.usersStore.user.value.groupId == 12
                ? this.distColumns
                : this.allColumns,
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        if (store_1.reportsStore.editModal) {
            await store_1.reportsStore.loadClaimAnalytics();
        }
        //E-017.1
        const startDate = store_1.reportsStore.startDate;
        const endDate = store_1.reportsStore.endDate;
        if (startDate && endDate) {
            this.onRetryCLaim = false;
            await store_1.reportsStore.loadClaimAnalytics(null, null, startDate, endDate);
            this.onRetryCLaim = true;
        }
    }
    componentWillUnmount() {
        store_1.reportsStore.claimAnalyticsData = null;
    }
    render() {
        var _a;
        const storeData = store_1.reportsStore.claimAnalyticsData;
        //   // B-091
        //   if (!usersStore.permissions.ReadPharmacies) {
        //   let filteredDataAsPerPharmacy = storeData?.filter((item: any) => {
        //     return usersStore.user.value.sites?.includes(item.siteId);
        //   });
        //   this.storeData.rowData = filteredDataAsPerPharmacy;
        // } else {
        //   this.storeData.rowData = storeData;
        // }
        // B-107 claim distributor
        const distRoles = store_2.usersStore.user.value.groupId == 10 || store_2.usersStore.user.value.groupId == 11 || store_2.usersStore.user.value.groupId == 12;
        if (distRoles) {
            this.storeData.rowData = storeData;
        }
        else {
            if (!store_2.usersStore.permissions.ReadPharmacies) {
                let filteredDataAsPerPharmacy = storeData === null || storeData === void 0 ? void 0 : storeData.filter((item) => {
                    var _a;
                    return (_a = store_2.usersStore.user.value.sites) === null || _a === void 0 ? void 0 : _a.includes(item.siteId);
                });
                this.storeData.rowData = filteredDataAsPerPharmacy;
            }
            else {
                this.storeData.rowData = storeData;
            }
        }
        const loadingData = store_1.reportsStore.showLoader;
        //E-017.1
        if ((store_1.reportsStore === null || store_1.reportsStore === void 0 ? void 0 : store_1.reportsStore.claimAnalyticsData) === null ? false : (_a = store_1.reportsStore.claimAnalyticsData) === null || _a === void 0 ? void 0 : _a.length) {
            this.onRetryCLaim = true;
        }
        //E-017.1
        if (!this.onRetryCLaim) {
            return (React.createElement("div", { style: { display: "float", marginLeft: "50%", top: "50%" } },
                React.createElement(ui_1.UiLoadingIndicator, null),
                React.createElement("div", null, "Loading Data...")));
        }
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(claim_analytics_header_1.ClaimAnalyticsHeader, { title: "Claim Analytics", withDatePicker: true }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement("button", { hidden: !store_2.usersStore.user.value.admin, onClick: () => {
                            this.storeData.gridApi.setQuickFilter(this.mdsView ? null : "MDS Approved");
                            this.mdsView = !this.mdsView;
                        } },
                        "MDS View ",
                        this.mdsView && "(Enabled)"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => (this.storeData.gridApi = params.api), rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, 
                        /* this is where we provide custom components */
                        frameworkComponents: this.storeData.frameworkComponents, 
                        /* this is where we enable multiple column sorting with 'ctrl' key/ 'Cmd' key on apple (default was the 'shift' key) */
                        multiSortKey: this.storeData.multiSortKey, 
                        /* this is where we provide animation while sorting */
                        animateRows: true, 
                        /* this is where we enable the sidebar with pivoting and filtering */
                        sideBar: true, groupMultiAutoColumn: true, floatingFilter: this.storeData.floatingFilter, 
                        /* disable Excel export until we are able to handle export in the back end - only CSV export available for now */
                        suppressExcelExport: true, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(claim_analytics_header_1.ClaimAnalyticsHeader, { title: "Claim Analytics", withDatePicker: true }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(claim_analytics_header_1.ClaimAnalyticsHeader, { title: "Claim Analytics", withDatePicker: true }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
__decorate([
    mobx_1.observable
], ClaimAnalytics.prototype, "mdsView", void 0);
ClaimAnalytics = __decorate([
    mobx_react_1.observer
], ClaimAnalytics);
exports.ClaimAnalytics = ClaimAnalytics;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/claim-analytics.tsx
// module id = 3877
// module chunks = 0